// Date helpers for memberships and role periods. The API sends DateOnly as "yyyy-MM-dd"; all math works
// on those strings (UTC for day arithmetic), so the browser time zone never shifts a day.

const pad = (n) => String(n).padStart(2, '0');

// Today in local time as "yyyy-MM-dd" (toISOString would be UTC and can be a day off around midnight).
export function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export const isoDate = (value) => (value ? String(value).slice(0, 10) : null);

export const yearOf = (iso) => Number(String(iso).slice(0, 4));

export const endOfYear = (year) => `${year}-12-31`;

export function addDays(iso, days) {
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}

// "2026-05-01" -> "01.05.2026"
export function formatDate(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return d && m && y ? `${d}.${m}.${y}` : String(iso);
}

// Range ends today or later (open-ended counts) → it still affects future events.
export const reachesDate = (to, iso) => !to || isoDate(to) >= iso;

export const coversDate = (from, to, iso) => isoDate(from) <= iso && reachesDate(to, iso);

// Two ranges (null end = open) share at least one day.
export function rangesOverlap(aFrom, aTo, bFrom, bTo) {
  const max = '9999-12-31';
  return isoDate(aFrom) <= (isoDate(bTo) ?? max) && isoDate(bFrom) <= (isoDate(aTo) ?? max);
}

// "01.01.2026 – 31.12.2026", "seit 01.01.2024" (open, started), "ab 01.01.2027" (open, future).
export function rangeLabel(from, to, today = todayIso()) {
  if (to) return `${formatDate(from)} – ${formatDate(to)}`;
  return `${isoDate(from) <= today ? 'seit' : 'ab'} ${formatDate(from)}`;
}
